import { useId } from 'react';
import type { ToolFieldChange } from '@reach/shared-types/tool-history';
import { TOOL_HISTORY_COPY, getToolHistoryFieldLabel } from './tool-history-constants';
import styles from './ToolHistory.module.css';

export const ToolHistoryChange = ({ change }: { change: ToolFieldChange }) => {
  const titleId = useId();
  const label = getToolHistoryFieldLabel(change.field);
  return (
    <section className={styles.change} aria-labelledby={titleId}>
      <h3 id={titleId}>{label}</h3>
      <dl>
        <div>
          <dt>{TOOL_HISTORY_COPY.before}</dt>
          <dd>
            <pre>{change.before ?? TOOL_HISTORY_COPY.unset}</pre>
          </dd>
        </div>
        <div>
          <dt>{TOOL_HISTORY_COPY.after}</dt>
          <dd>
            <pre>{change.after ?? TOOL_HISTORY_COPY.unset}</pre>
          </dd>
        </div>
      </dl>
    </section>
  );
};
